<script>
import Vue from 'vue'
import axios from 'axios'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import required from 'vuelidate/lib/validators/required'

/**
 * Agregar Licencias Component
 */
export default {
  components: { Layout, PageHeader },
  page: {
    title: 'Licencia',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      title: 'Licencia',
      form: {
        idPago: '',
        idContribuyente: '',
        colonia: '',
        CP: '',
        domicilio: '',
        establecimiento: '',
        giro: '',
        poblacion: '',
        ramo: '',
        RFC: '',
        telefono: '',
        nombre: '',
        folioPago:'',
      },
      items: [
        {
          text: 'Sistemas Tributario',
          href: '/',
        },
        {
          text: 'Pagos',
          href: '/pagos/add',
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
      submitted: false,
      isBusy: false,
    }
  },
  validations: {
    form:{
      folioPago:{
        required,
      },
      nombre:{
        required,
      },
      establecimiento:{
        required,
      },
      domicilio:{
        required,
      },
      telefono:{
        required,
      },
      poblacion:{
        required,
      },
      colonia:{
        required,
      },      
      giro:{
        required,
      },
      RFC:{
        required,
      },
      CP:{
        required,
      },
      ramo:{
        required,      
      }

    }
  },
  computed: {},
  mounted() {},
  methods: {
    _validations() {
      return new Promise((resolve) => {
        if (this.$v.$error || !this.$v.$pending) {
          return resolve()
        }
        let poll = setInterval(() => {
          if (!this.$v.$pending) {
            clearInterval(poll)
            resolve()
          }
        }, 200)
      })
    },

    async isValid() {
      this.$v.$reset()
      this.$v.$touch()
      await this._validations()
      return Promise.resolve(!this.$v.$error)
    },

    async handleSubmit(e) {

      this.submitted = true
      const valid = await this.isValid()
      this.isBusy = false

      if (valid) {
        this.isBusy = true
      return axios
        .post(appConfig.recursosApi.licencia, this.form)
        .then((response) => {
          this.form = {
            idPago: '',
            idContribuyente: '',
            colonia: '',
            CP: '',
            domicilio: '',
            establecimiento: '',
            giro: '',
            poblacion: '',
            ramo: '',
            RFC: '',
            telefono: '',
            nombre: '',
            folioPago:'',
          }
          this.$router.push('/licencias/index/true')
          window.open(
            appConfig.recursosApi.urlPrincipal +'/Reportes/licencia/'+ response.data.id,
            '_blank',
            'location=yes,height=570,width=520,scrollbars=yes,status=yes'
          )
          this.isBusy = false
        })
        .catch((r) => {
          Vue.swal({
              type: 'error',
              title: '',
              text: r.response.data.mensaje,
              confirmButtonClass: 'btn btn-confirm mt-2',
            })
        });
        }
    },
    loadConceptos(query = '') {
      this.isLoadingComboConceptos = true
      this.requestComboConceptos.filter = query
      axios
        .get(appConfig.recursosApi.conceptos, {
          params: this.requestComboConceptos,
        })
        .then((response) => {
          this.listadoConceptos = response.data.result
          this.isLoadingComboConceptos = false
          return this.data
        })
        .catch(() => {
          this.listadoConceptos = []
          this.isLoadingComboConceptos = false
          // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
          //                     this.$router.push('/500');
        })
    },
    loadContribuyentes(query = '') {
      this.isLoadingComboContribuyentes = true
      this.requestComboContribuyentes.filter = query
      axios
        .get(appConfig.recursosApi.contribuyentes, {
          params: this.requestComboContribuyentes,
        })
        .then((response) => {
          this.listadoContribuyentes = response.data.result
          this.isLoadingComboContribuyentes = false
          return this.data
        })
        .catch(() => {
          this.listadoContribuyentes = []
          this.isLoadingComboContribuyentes = false
          // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
          this.$router.push('/500')
        })
    },
    buscarPago() {

      if(this.form.folioPago=== ""){
        this.form.idContribuyente = "";
          this.form.nombre = "";
          this.form.RFC = "";
          this.form.colonia = "";
          this.form.CP = "";
          this.form.telefono = "";
          this.form.domicilio = "";
          this.form.idPago = ""
        return;
      }
      axios
        .get(appConfig.recursosApi.detallepago +"folio/" +this.form.folioPago)
        .then((response) => {
          this.form.idContribuyente = response.data.idContribuyente
          this.form.nombre = response.data.nombre
          this.form.RFC = response.data.rfc
          this.form.colonia = response.data.colonia
          this.form.CP = response.data.cp
          this.form.telefono = response.data.telefono
          this.form.domicilio = response.data.domicilio
          this.form.idPago = response.data.idPago
        })
        .catch((r) => {          
          Vue.swal({
              type: 'error',
              title: '',
              text: r.response.data.mensaje,
              confirmButtonClass: 'btn btn-confirm mt-2',
            })
        })
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <form @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col-lg-6">
          <div class="card-box">
            <h4 class="header-title m-t-0">Generar Licencia</h4>
            <p class="text-muted font-14 m-b-20"
              >Ingresa la información del contribuyente.</p
            >
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>
                  Folio Cobro
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.folioPago"
                  type="text"
                  name="folioPago"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.folioPago.$error,
                  }"
                  @blur="buscarPago"                  
                />
                 <div
                  v-if="submitted && $v.form.folioPago.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.folioPago.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
              <div class="form-group col-md-6">
                <label for="name">
                  RFC
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.RFC"
                  type="text"
                  name="RFC"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.RFC.$error,
                  }"
                />
              </div>
               <div
                  v-if="submitted && $v.form.RFC.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.RFC.required"
                    >El campo es requerido.</span
                  >
                </div>
            </div>

            <!-- Datos Usuario -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>
                  Nombre
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.nombre"
                  type="text"
                  name="nombre"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.nombre.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.nombre.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.nombre.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>
                  Establecimiento
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.establecimiento"
                  type="text"
                  name="razonSocial"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.establecimiento.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.establecimiento.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.establecimiento.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>
                  Domicilio
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.domicilio"
                  type="text"
                  name="domicilio"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.domicilio.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.domicilio.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.domicilio.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>
                  Colonia
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.colonia"
                  type="text"
                  name="colonia"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.colonia.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.colonia.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.colonia.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
              <div class="form-group col-md-4">
                <label>
                  Poblacion
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.poblacion"
                  type="text"
                  name="poblacion"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.poblacion.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.poblacion.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.poblacion.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
              <div class="form-group col-md-4">
                <label>
                  Codigo Postal
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.CP"
                  type="text"
                  name="CP"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.CP.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.CP.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.CP.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>
                  Teléfono
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.telefono"
                  type="text"
                  name="telefono"
                  class="form-control"
                  placeholder=""
                />
              </div>
              <div class="form-group col-md-4">
                <label>
                  Giro
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.giro"
                  type="text"
                  name="giro"
                  class="form-control"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && $v.form.giro.$error,
                  }"

                />
                <div
                  v-if="submitted && $v.form.giro.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.giro.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
              <div class="form-group col-md-4">
                <label>
                  Ramo
                  <span class="text-danger">*</span>
                </label>
                <select
                  v-model="form.ramo"
                  type="string"
                  name="TipoId"
                  class="custom-select"
                  :class="{
                    'is-invalid': submitted && $v.form.ramo.$error,
                  }"
                >
                  <option value="Industria">Industria</option>
                  <option value="Comercio">Comercio</option>
                  <option value="Servicio">Servicio</option>
                  <option value="Niguno">Ninguno</option>
                </select>
                <div
                  v-if="submitted && $v.form.ramo.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.ramo.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
            </div>
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">
                <b-spinner v-show="isBusy" small></b-spinner> Generar</button
              >
              <router-link class="btn btn-secondary m-l-5 ml-1" to="/">
                Cancelar</router-link
              >
            </div>
          </div>
          <!-- end card-box -->
        </div>
      </div>
    </form>
  </Layout>
</template>